import { render } from "./PLChart.vue?vue&type=template&id=7b4bbd7a"
import script from "./PLChart.vue?vue&type=script&lang=js"
export * from "./PLChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__